import TextButton, { TextButtonProps } from '~components/ui/button/text-button'

const DialogTextButton = ({
  priority = 'tertiary',
  size = 'large',
  children,
  className,
  onClick,
}: TextButtonProps) => {
  return (
    <TextButton size={size} priority={priority} onClick={onClick} className={className}>
      {children}
    </TextButton>
  )
}

export default DialogTextButton
